"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useReferenceGrammarID;

var _WebChatReduxContext = require("./internal/WebChatReduxContext");

function useReferenceGrammarID() {
  return [(0, _WebChatReduxContext.useSelector)(function (_ref) {
    var referenceGrammarID = _ref.referenceGrammarID;
    return referenceGrammarID;
  })];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VSZWZlcmVuY2VHcmFtbWFySUQudHMiXSwibmFtZXMiOlsidXNlUmVmZXJlbmNlR3JhbW1hcklEIiwicmVmZXJlbmNlR3JhbW1hcklEIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBRWUsU0FBU0EscUJBQVQsR0FBMkM7QUFDeEQsU0FBTyxDQUFDLHNDQUFZO0FBQUEsUUFBR0Msa0JBQUgsUUFBR0Esa0JBQUg7QUFBQSxXQUE0QkEsa0JBQTVCO0FBQUEsR0FBWixDQUFELENBQVA7QUFDRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlU2VsZWN0b3IgfSBmcm9tICcuL2ludGVybmFsL1dlYkNoYXRSZWR1eENvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VSZWZlcmVuY2VHcmFtbWFySUQoKTogW3N0cmluZ10ge1xuICByZXR1cm4gW3VzZVNlbGVjdG9yKCh7IHJlZmVyZW5jZUdyYW1tYXJJRCB9KSA9PiByZWZlcmVuY2VHcmFtbWFySUQpXTtcbn1cbiJdfQ==